document.addEventListener("DOMContentLoaded", function () {
  // console.log("DOM loaded");
  if(window.innerWidth > 768)
  {
    var predictiveSearch2 = document.querySelector(".header-layout .search__input");

      if (predictiveSearch2) {
        // console.log("predictiveSearch2 element found");
    
        predictiveSearch2.addEventListener("click", function () {
          // console.log("predictiveSearch2 clicked");
    
          setTimeout(function () {
            // console.log("Timeout after click executed");
            window.addEventListener("scroll", function () {
              // console.log("Scroll event triggered");
    
              var autoCompleteWrapper = document.querySelector(
                ".wizzy-autocomplete-wrapper"
              );
              if (!autoCompleteWrapper) {
                // console.log("autoCompleteWrapper NOT found");
                return;
              }
    
              var predictiveSearch2 = document.querySelector(".header-layout .search__input");
    
              if (predictiveSearch2) {
                var positionInfo = predictiveSearch2.getBoundingClientRect(),
                  top = positionInfo.top + positionInfo.height;
                // console.log("Setting top to:", top + "px");
                autoCompleteWrapper.style.setProperty(
                  "top",
                  top + "px",
                  "important"
                );
              } else {
                // console.log("predictiveSearch2 element NOT found on scroll");
              }
          });
        }, 250);
      });
    } else {
    // console.log("predictiveSearch2 element NOT found on DOMContentLoaded");
  }
  

  }
   
});

window.onWizzyScriptLoaded = function () {
window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      console.log("WIZZY INIT");
      data.common.lazyDOMConfig.searchInputIdentifiers = [
          {
              dom: ".search__input",
              type: "search"
          }
      ];
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((product) => {
        let price = parseFloat(
          product.price.toString().replace(/[^0-9.]/g, "")
        );
        product.price = Math.floor(price);
        product.isFromPersonalizedCollection = false;
        let sellingPrice = parseFloat(
          product.sellingPrice.toString().replace(/[^0-9.]/g, "")
        );
        product.sellingPrice = Math.floor(sellingPrice);
      });
      data.forEach((product) => {
        product.categories.forEach((category) => {
          if (category.id === "personalized-products") {
            product.isFromPersonalizedCollection = true;
          }
        });
      });
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {

      if(data.filters.type === "AUTOCOMPLETE_DEFAULT")
      {
        data.filters.getAllVariants = false;
        data.filters.sort = [{
          "field": "product_bestsellers_sortOrder:float",
          "order": "asc"
        }];
      }
      return data;
    });
};
// window.onWizzyLoaded.push(wizzyEvents);
